// ============================================================================
// Notifications — frontend client for /api/v1/notifications
// ============================================================================
import { api } from '@gumahub/shared';

interface ApiResponse<T> { success: boolean; data?: T; error?: string; }

export interface AppNotification {
  notificationId: string; category: string; title: string; body?: string | null;
  linkUrl?: string | null; sourceModule?: string | null; isRead: boolean; createdAt: string;
}

class NotificationService {
  private base = '/notifications';
  list(): Promise<ApiResponse<AppNotification[]>> { return api.get(this.base); }
  unreadCount(): Promise<ApiResponse<{ count: number }>> { return api.get(`${this.base}/unread-count`); }
  markRead(id: string): Promise<ApiResponse<any>> { return api.post(`${this.base}/${id}/read`, {}); }
  markAllRead(): Promise<ApiResponse<any>> { return api.post(`${this.base}/read-all`, {}); }
}
export const notificationService = new NotificationService();
